module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAiCAYAAAA3WXuFAAAA90lEQVRYhe2YsWrCUBSGv6hbFx/CB1GnPkBdpeDoLLoEcqdSOncWcbQP4KZjHqKv0TG5ckJstUPPTcAmyPngQi78/80HOcMlkfceoAtENIt3zmUitAGmDcuc2YpQBnTa4UMuQr7cLICPhkSegLfiyf/wLG7/vZIkoXx3QVs+1TcmpGFCGiakYUIaJqRhQhompGFCGpdX2Fdg35DHI7Dkl1ArsBnSEKG0RT6pzFAfmAAPgaUBMA/MvgOfgdkvYBfVmOkhcAjMjoDjXwHn3NX+LoZ6fKNsLaEVEFfIx2XnJkIz4KXK4SXSkW4QvQoHrwH5l1SHPKgEnADY+KS6n3pT0wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/programme_educloud/icon_ep1.png
// module id = 7txV
// module chunks = 0